import React from 'react';
import { Box } from '@mui/material';
import { Rule as RuleIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Contest } from '../../models/types';
import { EmptyState } from '../ui/EmptyState';

// Only rules actually set on the contest are listed.
export const ContestRulesTab = ({ contest }: { contest: Contest }) => {
  const { t } = useTranslation('contests');
  const rules = [
    contest.minPace ? { label: t('rules.minPace'), value: t('rules.paceValue', { value: contest.minPace.toFixed(1) }) } : null,
    contest.maxPace ? { label: t('rules.maxPace'), value: t('rules.paceValue', { value: contest.maxPace.toFixed(1) }) } : null,
    contest.minDistance ? { label: t('rules.minDistance'), value: t('common:units.km', { value: contest.minDistance.toFixed(1) }) } : null,
  ].filter((r): r is { label: string; value: string } => r !== null);

  if (rules.length === 0) {
    return (
      <EmptyState
        icon={<RuleIcon />}
        title={t('rules.emptyTitle')}
        description={t('rules.emptyDescription', { activity: t(`activityType.${contest.activityType || 'Run'}`).toLowerCase() })}
      />
    );
  }

  return (
    <Box sx={{ p: '20px 16px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 1.5 }}>
      {rules.map(rule => (
        <Box key={rule.label} sx={{ border: '1px solid var(--border)', borderRadius: '10px', p: 1.75, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Box component="span" sx={{ fontSize: 12, color: 'var(--muted)' }}>{rule.label}</Box>
          <Box component="span" sx={{ fontSize: 18, fontWeight: 600 }}>{rule.value}</Box>
        </Box>
      ))}
    </Box>
  );
};
